<!-- Desktop `skelReview`; tablet 768pt estimate (coupon top-right); mobile 390pt four-card stack. -->
<div class="review-and-pay-skeleton" aria-hidden="true" data-testid="review-and-pay-skeleton">
  <!-- Desktop ≥1200: two rows of three + three-column estimate. -->
  <div class="review-and-pay-skeleton__desktop">
    <app-skeleton-block width="268" height="30" />
    <app-skeleton-block width="168" height="11" tone="secondary" />

    <div class="review-and-pay-skeleton__notice">
      <app-skeleton-block width="20" height="20" radius="circle" [animated]="false" />
      <app-skeleton-block width="520" height="12" tone="secondary" />
    </div>

    <app-skeleton-block width="430" height="12" tone="secondary" />

    <div class="review-and-pay-skeleton__card-row">
      @for (card of desktopCardPlaceholders; track card) {
        <div class="review-and-pay-skeleton__card">
          <div class="review-and-pay-skeleton__card-header">
            <app-skeleton-block width="140" height="15" />
            <app-skeleton-block width="34" height="12" tone="secondary" />
          </div>
          <div class="review-and-pay-skeleton__card-divider"></div>
          <div class="review-and-pay-skeleton__card-lines">
            @for (lineWidth of desktopCardLineWidths; track lineWidth) {
              <app-skeleton-block [width]="lineWidth" height="11" tone="secondary" />
            }
          </div>
        </div>
      }
    </div>

    <div class="review-and-pay-skeleton__card-row">
      @for (card of desktopCardPlaceholders; track card) {
        <div class="review-and-pay-skeleton__card">
          <div class="review-and-pay-skeleton__card-header">
            <app-skeleton-block width="140" height="15" />
            <app-skeleton-block width="34" height="12" tone="secondary" />
          </div>
          <div class="review-and-pay-skeleton__card-divider"></div>
          <div class="review-and-pay-skeleton__card-lines">
            @for (lineWidth of desktopCardLineWidths; track lineWidth) {
              <app-skeleton-block [width]="lineWidth" height="11" tone="secondary" />
            }
          </div>
        </div>
      }
    </div>

    <div class="review-and-pay-skeleton__estimate">
      <app-skeleton-block width="300" height="26" />
      <div
        class="review-and-pay-skeleton__estimate-grid review-and-pay-skeleton__estimate-grid--desktop"
      >
        <div class="review-and-pay-skeleton__estimate-arrival">
          <app-skeleton-block width="180" height="15" />
          <app-skeleton-block height="118" radius="card" tone="emphasis" />
        </div>
        <div class="review-and-pay-skeleton__estimate-lines">
          @for (line of estimateLinePlaceholders; track line) {
            <div class="review-and-pay-skeleton__estimate-row">
              <app-skeleton-block width="120" height="11" tone="secondary" />
              <app-skeleton-block width="58" height="11" tone="secondary" />
            </div>
          }
          <div class="review-and-pay-skeleton__card-divider"></div>
          <div class="review-and-pay-skeleton__estimate-row">
            <app-skeleton-block width="68" height="15" />
            <app-skeleton-block width="76" height="15" />
          </div>
        </div>
        <div class="review-and-pay-skeleton__estimate-payment">
          <app-skeleton-block width="200" height="14" />
          <div class="review-and-pay-skeleton__coupon-row">
            <div class="review-and-pay-skeleton__coupon-input">
              <app-skeleton-block width="100%" height="52" radius="card" tone="emphasis" />
            </div>
            <app-skeleton-block width="92" height="52" radius="card" tone="emphasis" />
          </div>
        </div>
      </div>
    </div>

    <div class="review-and-pay-skeleton__divider"></div>
    <div class="review-and-pay-skeleton__actions">
      <app-skeleton-block width="84" height="46" radius="card" tone="secondary" />
      <div class="review-and-pay-skeleton__actions-right">
        <app-skeleton-block width="168" height="46" radius="card" tone="secondary" />
        <app-skeleton-block width="200" height="46" radius="card" />
      </div>
    </div>
  </div>

  <!-- Tablet 768–1199: one 6-card grid; estimate coupon top-right (no yellow banner stub). -->
  <div class="review-and-pay-skeleton__tablet">
    <app-skeleton-block width="210" height="30" />
    <app-skeleton-block width="170" height="11" tone="secondary" />

    <div class="review-and-pay-skeleton__notice review-and-pay-skeleton__notice--tablet">
      <app-skeleton-block width="22" height="22" radius="circle" [animated]="false" />
      <app-skeleton-block width="540" height="12" tone="secondary" />
    </div>

    <app-skeleton-block width="450" height="12" tone="secondary" />

    <div class="review-and-pay-skeleton__tablet-cards">
      @for (card of tabletCardPlaceholders; track card) {
        <div class="review-and-pay-skeleton__card review-and-pay-skeleton__card--tablet">
          <div class="review-and-pay-skeleton__card-header">
            <app-skeleton-block width="118" height="15" />
            <app-skeleton-block width="30" height="12" tone="secondary" />
          </div>
          <div class="review-and-pay-skeleton__card-divider"></div>
          <div class="review-and-pay-skeleton__card-lines">
            @for (lineWidth of tabletCardLineWidths; track lineWidth) {
              <app-skeleton-block [width]="lineWidth" height="11" tone="secondary" />
            }
          </div>
        </div>
      }
    </div>

    <div class="review-and-pay-skeleton__estimate review-and-pay-skeleton__estimate--tablet">
      <app-skeleton-block width="290" height="26" />
      <div
        class="review-and-pay-skeleton__estimate-grid review-and-pay-skeleton__estimate-grid--tablet"
      >
        <div class="review-and-pay-skeleton__estimate-arrival">
          <app-skeleton-block width="180" height="15" />
          <app-skeleton-block height="128" radius="shell" tone="emphasis" />
        </div>
        <div class="review-and-pay-skeleton__estimate-right">
          <app-skeleton-block width="176" height="14" />
          <div class="review-and-pay-skeleton__coupon-row">
            <div class="review-and-pay-skeleton__coupon-input">
              <app-skeleton-block width="100%" height="54" radius="card" />
            </div>
            <app-skeleton-block width="92" height="54" radius="card" tone="emphasis" />
          </div>
          <div class="review-and-pay-skeleton__estimate-lines">
            @for (line of estimateLinePlaceholders; track line) {
              <div class="review-and-pay-skeleton__estimate-row">
                <app-skeleton-block width="140" height="11" tone="secondary" />
                <app-skeleton-block width="56" height="11" tone="secondary" />
              </div>
            }
            <div
              class="review-and-pay-skeleton__card-divider review-and-pay-skeleton__card-divider--strong"
            ></div>
            <div class="review-and-pay-skeleton__estimate-row">
              <app-skeleton-block width="66" height="15" />
              <app-skeleton-block width="76" height="15" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="review-and-pay-skeleton__divider review-and-pay-skeleton__divider--tablet"></div>
    <div class="review-and-pay-skeleton__actions">
      <app-skeleton-block width="86" height="52" radius="card" tone="secondary" />
      <div class="review-and-pay-skeleton__actions-right">
        <app-skeleton-block width="166" height="52" radius="card" tone="secondary" />
        <app-skeleton-block width="198" height="52" radius="card" />
      </div>
    </div>
  </div>

  <div class="review-and-pay-skeleton__mobile">
    <app-skeleton-block width="190" height="30" />
    <app-skeleton-block width="168" height="12" tone="secondary" />

    <div class="review-and-pay-skeleton__mobile-notice">
      <app-skeleton-block width="22" height="22" radius="circle" [animated]="false" />
      <div class="review-and-pay-skeleton__mobile-notice-copy">
        @for (width of mobileNoticeLineWidths; track width) {
          <app-skeleton-block [width]="width" height="12" tone="secondary" />
        }
      </div>
      <app-skeleton-block width="22" height="22" radius="circle" [animated]="false" />
    </div>

    <div class="review-and-pay-skeleton__mobile-intro">
      <app-skeleton-block width="100%" height="12" tone="secondary" />
      <app-skeleton-block width="58%" height="12" tone="secondary" />
    </div>

    @for (card of mobileCardPlaceholders; track card) {
      <div class="review-and-pay-skeleton__mobile-card">
        <div class="review-and-pay-skeleton__card-header">
          <app-skeleton-block width="168" height="17" />
          <app-skeleton-block width="34" height="13" tone="secondary" />
        </div>
        <div class="review-and-pay-skeleton__card-divider"></div>
        <div class="review-and-pay-skeleton__card-lines">
          @for (lineWidth of mobileCardLineWidths; track lineWidth; let i = $index) {
            <app-skeleton-block
              [width]="lineWidth"
              height="12"
              tone="secondary"
              [class.review-and-pay-skeleton__mobile-line-gap]="i === 3"
            />
          }
        </div>
      </div>
    }
  </div>
</div>
